import CustomCamera, { CameraSettings } from './CustomCamera';

export class CameraOrtho extends CustomCamera {
    protected override defaultSettings(): CameraSettings {
        return {
            ...super.defaultSettings(),
            enablePan: true,
            enableZoom: true,
            trackBallZoom: false,
        };
    }
}
